<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { _trackPageview, _trackEvent } from '@/util'
export default {
  name: 'App',
  data() {
    return {
      second: 0,
      timer: null,
      id: ''
    }
  },
  watch: {
    '$route': {
      handler(newVal, oldVal) {
        _trackEvent('页面停留时间', '页面', oldVal.fullPath, this.second, oldVal.fullPath)
        // _trackEvent('跳转至新页面', '跳转', newVal.fullPath, this.second, oldVal.fullPath)
        const origin = window.location.origin
        const pathName = window.location.pathname
        _trackPageview(origin + pathName + '#' + newVal.fullPath, pathName + '#' + oldVal.fullPath) // pv
        if (this.timer) {
          window.clearInterval(this.timer)
          this.second = 0
          this.timer = window.setInterval(() => {
            this.second++
          }, 1000)
        }
      }
    }
  },
  mounted() {
    if (process.env.VUE_APP_ENV === 'production') {
      this.id = '1278021027'
    } else {
      this.id = '1279153505' // 测试环境
    }
    // const script = document.createElement('script')
    // script.src = `https://s4.cnzz.com/z_stat.php?id=${this.id}&web_id=${this.id}`
    // script.language = 'JavaScript'
    // document.body.appendChild(script) //为了 PENETRATION TEST 注释掉2022.12
    this.second = 0
    this.timer = window.setInterval(() => {
      this.second++
    }, 1000)

    window.addEventListener('beforeunload', (event) => {
      const location = window.location
      _trackEvent('页面停留时间', '页面', location.hash.substr(1), this.second, location.href)
    })
  }
}
</script>

<style lang="scss" scoped>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>

